export let stringToColour = (str) => {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var colour = '#';
  for (var i = 0; i < 3; i++) {
    var value = (hash >> (i * 8)) & 0xFF;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
}

export let convertMsToTimeString = (ms) => {
  if (isNaN(ms)) {
    return 'Invalid format'
  } else if (ms < 60000) {
    return Math.floor(ms / 1000) + 's';
  } else if (ms < 3600000) {
    return Math.floor(ms / 60000) + 'm ' + ((ms % 6000) >= 1000 ? Math.floor((ms % 6000) / 1000) + 's' : '');
  } else {
    return Math.floor(ms / 3600000) + 'h ' + ((ms % 3600000) >= 1000 ? Math.floor((ms % 3600000) / 1000) + 'm' : '');
  }
}

export let toAgoFormat = (date) => {
  console.log('date', date);
  const millisecondsDiff = (new Date().getTime()) - date.getTime();
  console.log(millisecondsDiff)
  console.log('millisecondsDiff', millisecondsDiff);

  if (millisecondsDiff <= 0) {
    return 'A moment ago';
  } else if (millisecondsDiff < 60000) {
    return Math.floor(millisecondsDiff / 1000) + 's ago';
  } else if (millisecondsDiff < 3600000) {
    return Math.floor(millisecondsDiff / 60000) + 'm ago';
  } else if (millisecondsDiff < 86400000) {
    return Math.floor(millisecondsDiff / 3600000) + 'h ago';
  } else {
    return Math.floor(millisecondsDiff / 86400000) + 'd ago';
  }
}

const calcTotalPower = (tx, advInt, temperature) => {
	// cap operating temperature at 70C
	if (temperature > 70)
		return 0;

	// these are constants
	const a = 12.84;
	const b = 72.83;
	const p0 = 0.05;
	const ep = 5;
	return (a * 10**(tx/10.0)+ b) / (advInt + ep) + p0; // returns power consumption in mW
}

// this function converts power in mW to mA
const mW_to_mA = (power, voltage = 3.0) => {
	return power / voltage; // voltage is assumed to be constant (3.0V according to the battery's specification)
}

export let calcBatteryLife = (tx, advInt, temperature, capacity = 1000, consumRate = 0.7) => {
  if (!advInt) advInt = 100;
	// total consumption in mW is calculated and converted to mA
	const consumption = mW_to_mA(calcTotalPower(tx, advInt, temperature));

	// we assume that battery life at a temperature between 20 and 40 degrees is constant
	// or at least does not vary significantly if temperature is between 20 and 40
	// that is why we do not incorporate temperature in the formula
	if (temperature < 40)
		return (capacity / consumption * consumRate) / 24 // this is to convert mA into hours

	// otherwise, if temperature >= 40, then we take temperature into account
	// the coefficient of temperature is calculated as
	// (-0.02 * temperature + 1.6). This formula ensures that 40C corresponds to 0.8,
	// 50C - 0.6, 60C - 0.4...
	return ((-0.02 * temperature + 1.6) * (capacity / consumption * consumRate)) / 24; // this is to convert mA into hours
}

export let calcBatteryReplacementDate = (deploymentDate, tx, advInt, temperature, capacity = 1000, consumRate = 0.7) => {
  const batteryLife = calcBatteryLife(tx, advInt, temperature, capacity, consumRate);

  const expiredDate = new Date(deploymentDate);
  console.log('deploymentDate.getDate()', deploymentDate.getDate());
  expiredDate.setDate(deploymentDate.getDate() + Math.floor(batteryLife));
  return expiredDate.toDateString();
}

export let isBatteryMightExpired = (deploymentDate, tx, advInt, temperature, capacity = 1000, consumRate = 0.7) => {
  const batteryLife = calcBatteryLife(tx, advInt, temperature, capacity, consumRate);

  const expiredDate = new Date(deploymentDate);
  console.log('deploymentDate.getDate()', deploymentDate.getDate());
  expiredDate.setDate(deploymentDate.getDate() + Math.floor(batteryLife));
  return (expiredDate.getTime() < (new Date().getTime()));
}

export let exportToJsonFile = (jsonData) => {
    let dataStr = JSON.stringify(jsonData);
    let dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);

    let exportFileDefaultName = 'data.json';

    let linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
};

function parseJSONToCSVStr(jsonData) {
    if(jsonData.length == 0) {
        return '';
    }

    let keys = Object.keys(jsonData[0]);

    let columnDelimiter = ',';
    let lineDelimiter = '\n';

    let csvColumnHeader = keys.join(columnDelimiter);
    let csvStr = csvColumnHeader + lineDelimiter;

    jsonData.forEach(item => {
        keys.forEach((key, index) => {
            if( (index > 0) && (index < keys.length-1) ) {
                csvStr += columnDelimiter;
            }
            csvStr += item[key];
        });
        csvStr += lineDelimiter;
    });

    return encodeURIComponent(csvStr);;
}

export let exportToCsvFile = (jsonData) => {
    let csvStr = parseJSONToCSVStr(jsonData);
    let dataUri = 'data:text/csv;charset=utf-8,'+ csvStr;

    let exportFileDefaultName = 'data.csv';

    let linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
}
